export class MediaQuery {
  static readonly XXL = 1550;
  static readonly XL = 1200;
  static readonly MD = 992;
  static readonly SM = 768;
  static readonly XS = 576;
  static readonly XXS = 360;
}
